const SELECTED_BUSINESS_KEY = '@selected_business';

export interface StoredBusiness {
  id: string;
  name: string;
  is_owner: boolean;
  is_onboarding_complete: boolean;
}

/**
 * Save the selected business to localStorage
 */
export const saveSelectedBusiness = (business: StoredBusiness): void => {
  try {
    localStorage.setItem(SELECTED_BUSINESS_KEY, JSON.stringify(business));
  } catch (error) {
    console.error('Failed to save selected business:', error);
  }
};

/**
 * Get the selected business from localStorage
 */
export const getSelectedBusiness = (): StoredBusiness | null => {
  try {
    const stored = localStorage.getItem(SELECTED_BUSINESS_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error('Failed to get selected business:', error);
    return null;
  }
};

/**
 * Clear the selected business from localStorage
 */
export const clearSelectedBusiness = (): void => {
  try {
    localStorage.removeItem(SELECTED_BUSINESS_KEY);
  } catch (error) {
    console.error('Failed to clear selected business:', error);
  }
};
